import * as Yup from 'yup';
import { filter, truncate } from 'lodash';
import ReactDOM from 'react-dom';
import QRCode from 'react-qr-code';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useRef } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import settingsOutline from '@iconify/icons-eva/settings-outline';
import questionMarkCircleOutline from '@iconify/icons-eva/question-mark-circle-outline';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  FormControlLabel,
  Switch,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  TextField,
  Box,
  CircularProgress,
  Tooltip,
  IconButton
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList, deleteUser } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user/list';
import  ProductToolbar  from 'src/components/_dashboard/user/list/ProductToolbar.js';
import  ProductsSearch  from 'src/components/_dashboard/blog/ProductsSearch.js';
import  ProductsMenu  from 'src/components/_dashboard/user/list/ProductsMenu.js';
import axios from 'axios';
import {BASE_URL, REST_API, REST_API_END_POINT, UNITS} from '../../constants/Defaultvalues';
import moment from 'moment';
import MaterialInventoryMenu from 'src/components/_dashboard/user/list/MaterialInventoryMenu';
import MaterialInventoryToolbar from 'src/components/_dashboard/user/list/MaterialInventoryToolbar';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import ReactToPrint from 'react-to-print';
import { Form, FormikProvider, useFormik } from 'formik';
import { LoadingButton } from '@material-ui/lab';
import { Autocomplete } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import { stubTrue } from 'lodash';
import FinishedProductmenu from 'src/components/_dashboard/blog/FinishedProductmenu';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import InventoryStockComparison from 'src/components/_dashboard/receive-inventory/InventoryStockComparison';


export default function MaterialPartialFinishedProducts({prodId, viewFinishedProducts, unitName, unitQty,expectedPrice,retailMarkup,vpt_number,description,fromTask,fromListTransfer}) {
  const theme = useTheme();
  const componentRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const id = searchParams.get('id');
  const editId = parseInt(prodId);
  const [loading, setLoading] = useState(false)
  const [refreshData, setRefreshData] = useState(false)
  const [editFinishedProductId, setEditFinishedProductId] = useState()
  const [editData, setEditData] = useState([])
  const [openAddFinishedProduct, setOpenAddFinishedProduct] = useState(false)
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [filterSource, setFilterSource] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [ProductList, setProductList] = useState([]);
  const receivedData = location.state?.data;
  const { enqueueSnackbar } = useSnackbar();
  const userData = JSON.parse(localStorage.getItem('user'))
  const userId = userData.user_id
  const explodedPermissions =userData?.exploded_permissions
  const tableContainerRef = useRef(null);
  const [printerSettings, setPrinterSettings] = useState(false)
  const [partialModalOpen, setPartialModalOpen] = useState(false);
  const [openPartialPop, setOpenPartialPop] = useState(false);
  const [movingQty, setMovingQty] = useState(1);
  const [convertionUnit, setConvertionUnit] = useState(null);
  const [convertionQty, setConvertionQty] = useState(0);
  const [convertionUnitPrice, setConvertionUnitPrice] = useState(0);
  const [convertionTotalPrice, setConvertionTotalPrice] = useState(0);
  const [autoFill, setAutoFill] = useState(true);
  const [errors, setErrors] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: '', alignRight: false },
  { id: 'qrcode', label: 'QR Code', alignRight: false },
  { id: 'autofill', label: fromTask ? '' : 'Automate', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'partial_unit', label: fromTask ? '' : `Unit`, alignRight: false },
  { id: 'Sales_price', label: `Sales Price`, alignRight: false },

  { id: 'unit_cost', label: fromTask ? '' : `Unit Cost`, alignRight: false },
  // { id: 'unit_qty', label: 'Quantity', alignRight: false },
  { id: 'qty', label: `Total Qty`, alignRight: false },
  { id: 'total_cost', label: 'Total Cost', alignRight: false },
  { id: 'source', label: fromTask ? '' : 'Source', alignRight: false },
  { id: 'vendor', label: fromTask ? '' : 'Vendor Name', alignRight: false },
  // { id: 'timestamp', label: 'Added On', alignRight: false },
  { id: 'partial_size', label: 'Size', alignRight: false },
  { id: 'finished_product_barcode', label: 'Parent Barcode', alignRight: false },
  { id: 'status', label: 'Print Labels', alignRight: false },
  { id:'options', label: '', alignRight: false},      
  { id:'', label: '', alignRight: false},      
];

// ----------------------------------------------------------------------

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  useEffect( async () => {
    setLoading(true)
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-partial-finished-products`,{editId});
      const productListData = response.data.results;
      if(productListData){
        setProductList(productListData);
        // console.log("productListData : ",productListData);
      }
      else{
        setProductList([]);
      }
    }
      catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
      setLoading(false);
    }
  }, [receivedData, refreshData]);

  const fetchDataById = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}product/get-finished-product-by-id`,{editFinishedProductId});
      if(response.data.status === 1) {
        setEditData(response.data.results[0])
      }
      else{
        setEditData([])
      }
    }catch(error){
      console.log(error);
    }
  }

  useEffect(()=>{
    if(editFinishedProductId){
      fetchDataById()
    }
  },[editFinishedProductId])

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function applySortFilter(array, comparator, query, source) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    if (source) {
      if (source === 'Inventory') {
        return filter(array, (_user) => _user.source === 0);
      }
      else if (source === 'Vendor') {
        return filter(array, (_user) => _user.source === 1);
      }
    }
    return stabilizedThis.map((el) => el[0]);
  }
   
  const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = slicedData?.map((n) => n.id);
      const newSelectedNames = slicedData?.map((n) => n.name);
      setSelected(newSelecteds);
      setSelectedNames(newSelectedNames);
      return;
    }
    setSelected([]);
    setSelectedNames([]);
  };

  const handleClick = (event, id,name) => {
    const selectedIndex = selected?.indexOf(id);
    const selectedNameIndex = selectedNames?.indexOf(name);
    let newSelected = [];
    let newselectedNames = [];
    if (selectedIndex === -1) {
      newSelected = newSelected?.concat(selected, id);
      newselectedNames = newselectedNames?.concat(selectedNames, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected?.concat(selected?.slice(1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected?.concat(selected?.slice(0, -1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected?.concat(selected?.slice(0, selectedIndex), selected?.slice(selectedIndex + 1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, selectedNameIndex), selectedNames?.slice(selectedNameIndex + 1));
    }
    setSelected(newSelected);
    setSelectedNames(newselectedNames);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSelected([]);
    setSelectedNames([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0)
  };

  const handleFilterBySource = (event) => {
    setFilterSource(event);
    setPage(0)
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ProductList?.length) : 0;
  const filteredUsers = applySortFilter(ProductList, getComparator(order, orderBy), filterName, filterSource); //?.filter(item => item.qty > 0)
  const slicedData = filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const isUserNotFound = filteredUsers?.length === 0;

  // Kept for future auto-calc restore (unit cost from material / moving qty)
  // const unit_cost = expectedPrice || 0;
  // const materialConvertionFactor = 1;

  // const applyMovingQtyToConversion = (qtyNum) => {
  //   if (!qtyNum || Number(qtyNum) <= 0) {
  //     setConvertionQty(0);
  //     setConvertionUnitPrice(0);
  //     setConvertionTotalPrice(0);
  //     return;
  //   }
  //   const newConvertionQty = Number(qtyNum) * materialConvertionFactor;
  //   const unitCost = newConvertionQty > 0 ? unit_cost / materialConvertionFactor : 0;
  //   setConvertionQty(newConvertionQty);
  //   setConvertionUnitPrice(unitCost);
  //   setConvertionTotalPrice(unit_cost * Number(qtyNum));
  // };

  // Total Cost = Unit Cost × Conversion Qty (unit cost and qty stay independent of each other)
  const syncTotalFromUnitAndQty = (unitPrice, qty) => {
    const u = Number(unitPrice);
    const q = Number(qty) || 0;
    if (Number.isNaN(u)) {
      setConvertionTotalPrice(0);
      return;
    }
    setConvertionTotalPrice(u * q);
  };

  const resetPartialModalFields = () => {
    setConvertionUnit(null);
    setAutoFill(true);
    setErrors({});
    setMovingQty(1);
    setConvertionQty(0);
    setConvertionUnitPrice(0);
    setConvertionTotalPrice(0);
    // applyMovingQtyToConversion(1);
  };

  const handleSubmitAddPartial = async () => {
    const newErrors = {};
    if (!movingQty || movingQty <= 0) newErrors.movingQty = 'Quantity must be greater than zero';
    if (!convertionUnit) newErrors.convertionUnit = 'Required';
    const normalizedConvertionQty = convertionQty === '' || convertionQty === null || convertionQty === undefined
      ? 0
      : Number(convertionQty);
    if (!Number.isFinite(normalizedConvertionQty) || normalizedConvertionQty < 0) {
      newErrors.convertionQty = 'Conversion qty must be 0 or greater';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setSubmitLoading(true);
    setErrors({});
    try {
      const unitPrice = Number(convertionUnitPrice) || 0;
      const totalPrice = unitPrice * normalizedConvertionQty;
      // Manual total override when auto-calc was off — kept for future
      // const totalPrice = Number(convertionTotalPrice) || 0;
      const payload = {
        userId,
        material_id: editId,
        movingQty,
        convertionUnit,
        convertionQty: normalizedConvertionQty,
        convertionUnitPrice: unitPrice,
        convertionTotalPrice: totalPrice,
        autoFill
      };
      const response = await axios.post(`${REST_API_END_POINT}product/add-partial-finished-product`, payload);
      if (response?.data?.status === 1) {
        enqueueSnackbar(response.data.message || 'Partial finished product created', { variant: 'success' });
        setRefreshData(!refreshData);
        setOpenPartialPop(false);
        setPartialModalOpen(false);
        resetPartialModalFields();
      } else {
        enqueueSnackbar(response?.data?.message || 'Failed to create partial', { variant: 'error' });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error creating partial finished product', { variant: 'error' });
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <Container sx={{ pt: 1, px: 0 }}>
        {/* Header row — hidden per client requirement; uncomment to restore
        {!viewFinishedProducts && (
        <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={3} >
          <Typography sx={{py:3}} variant='h6'>Partial Finished Products</Typography>
          {viewFinishedProducts ? null :<Button 
            disabled={explodedPermissions?.some(permission => ['Add Finished Product'].includes(permission)) ? false : true}
            onClick={()=>{ setOpenAddFinishedProduct(true) }}
            variant="contained" startIcon={<Icon icon={trash2Outline} />} >
            Move to waste
          </Button>}
        </Stack>
        )}
        */}
        <Card>
          {/* <MaterialInventoryToolbar 
            numSelected={selected?.length} 
            filterName={filterName} 
            onFilterName={handleFilterByName}
            filterSource={filterSource}
            onFilterSource={handleFilterBySource}
            selectedName={selectedNames} 
            selected={selected} 
            onDelete={() => {setSelected([]);setPage(0);}}
            item="partial finished products"
          /> */}
          {/* Add Partial Finished Product button — hidden per client requirement; uncomment to restore
          <Stack sx={{ p: viewFinishedProducts ? 0 : 2 }}>
          {(viewFinishedProducts || fromListTransfer) ? null :<Button  
          sx={{mb:2 , width:'fit-content',marginLeft:'auto'}}
            disabled={explodedPermissions?.some(permission => ['Add Finished Product'].includes(permission)) ? false : true}
            onClick={() => {
              setPartialModalOpen(true);
              setOpenPartialPop(true);
              resetPartialModalFields();
            }}
            variant="contained" startIcon={<Icon icon={plusFill} />} >
            Add Partial Finished Product
          </Button>}
          </Stack>
          */}

          {/* Partial creation modal (reuses the same form as move-to-partial but used here to create a new partial) */}
          <Modal
                modalTitle={'Add Partial Finished Product'}
                open={partialModalOpen}
                handleClose={() => {
                  setOpenPartialPop(false);
                  setPartialModalOpen(false);
                  resetPartialModalFields();
                }}
              >
                <Grid container spacing={3} justifyContent="center">
                  <Grid item xs={12} md={8}>
                    <Stack spacing={3}>
                      <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                        {/* <TextField
                          fullWidth
                          label={(unitName || 'Unit') + ' Qty to be moved'}
                          type="number"
                          onKeyPress={(event) => {
                            if (
                              event.key === '-' ||
                              event.key === '+' ||
                              event.key === 'e' ||
                              event.key === '.' ||
                              event.key === ',' ||
                              event.key === ' '
                            ) {
                              event.preventDefault();
                            }
                            if (event.key === '0' && (!event.target.value || event.target.value === '0')) {
                              event.preventDefault();
                            }
                          }}
                          value={movingQty}
                          onChange={(e) => {
                            let inputQty = e.target.value.replace(/^0+/, '');
                            if (inputQty === '' || Number(inputQty) <= 0) {
                              setMovingQty('');
                              setErrors((prev) => ({ ...prev, movingQty: 'Quantity must be greater than zero' }));
                              return;
                            }
                            let qtyNum = Number(inputQty);
                            if (unitQty != null && qtyNum > unitQty) {
                              qtyNum = unitQty;
                            }
                            setMovingQty(qtyNum);
                            applyMovingQtyToConversion(qtyNum);
                            setErrors((prev) => ({ ...prev, movingQty: '' }));
                          }}
                          error={!!errors.movingQty}
                          helperText={errors.movingQty}
                        /> */}
                        <Autocomplete
                          fullWidth
                          id="combo-box-demo"
                          options={UNITS}
                          value={convertionUnit}
                          onChange={(event, newValue) => {
                            setConvertionUnit(newValue);
                            setErrors((prev) => ({ ...prev, convertionUnit: '' }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required
                              error={!!errors.convertionUnit}
                              helperText={errors.convertionUnit}
                              label="Select a conversion unit"
                            />
                          )}
                          getOptionLabel={(option) => (option.name ? option.name : '')}
                        />
                        <TextField
                          fullWidth
                          label={convertionUnit ? `${convertionUnit?.short_name} Qty` : 'Conversion Qty'}
                          type="number"
                          inputProps={{ min: 0, step: 1 }}
                          onKeyPress={(event) => {
                            if (
                              event.key === '-' ||
                              event.key === '+' ||
                              event.key === 'e' ||
                              event.key === 'E' ||
                              event.key === '.'
                            ) {
                              event.preventDefault();
                            }
                          }}
                          onKeyDown={(event) => {
                            if (event.key === '-' || event.key === 'Subtract') {
                              event.preventDefault();
                            }
                            const value = parseInt(event.target.value, 10) || 0;
                            if (event.key === 'ArrowDown' && value <= 0) {
                              event.preventDefault();
                            }
                          }}
                          value={convertionQty === '' || convertionQty === null || convertionQty === undefined ? '' : convertionQty}
                          onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === '') {
                              setConvertionQty('');
                              // Do not change unit cost based on qty — only refresh total
                              // setConvertionUnitPrice(0);
                              syncTotalFromUnitAndQty(convertionUnitPrice, 0);
                              setErrors((prev) => ({ ...prev, convertionQty: '' }));
                              return;
                            }
                            if (/^-/.test(raw)) {
                              setErrors((prev) => ({
                                ...prev,
                                convertionQty: 'Conversion qty must be 0 or greater',
                              }));
                              return;
                            }
                            const inputValue = parseInt(raw, 10);
                            if (Number.isNaN(inputValue) || inputValue < 0) {
                              setErrors((prev) => ({
                                ...prev,
                                convertionQty: 'Conversion qty must be 0 or greater',
                              }));
                              return;
                            }
                            // Do not derive unit cost from conversion qty — kept for future
                            // const unitCost = inputValue > 0 ? unit_cost / inputValue : 0;
                            // setConvertionUnitPrice(unitCost);
                            // setConvertionTotalPrice(unitCost * inputValue);
                            setConvertionQty(inputValue);
                            syncTotalFromUnitAndQty(convertionUnitPrice, inputValue);
                            setErrors((prev) => ({ ...prev, convertionQty: '' }));
                          }}
                          error={!!errors.convertionQty}
                          helperText={errors.convertionQty}
                        />
                        <TextField
                          fullWidth
                          label={'Unit Cost ($)'}
                          type="number"
                          inputProps={{ step: '0.01', min: 0 }}
                          value={
                            convertionUnitPrice === '' ||
                            convertionUnitPrice === null ||
                            convertionUnitPrice === undefined
                              ? ''
                              : convertionUnitPrice
                          }
                          onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === '') {
                              setConvertionUnitPrice('');
                              syncTotalFromUnitAndQty(0, convertionQty);
                              return;
                            }
                            const num = parseFloat(raw);
                            if (Number.isNaN(num)) return;
                            setConvertionUnitPrice(num);
                            // Total Cost = Unit Cost × Conversion Qty (does not change qty)
                            syncTotalFromUnitAndQty(num, convertionQty);
                          }}
                        />
                        <TextField
                          fullWidth
                          label={'Total Cost ($)'}
                          type="number"
                          disabled
                          inputProps={{ step: '0.01' }}
                          value={
                            convertionTotalPrice === '' ||
                            convertionTotalPrice === null ||
                            convertionTotalPrice === undefined
                              ? ''
                              : Number(convertionTotalPrice).toFixed(2)
                          }
                        />
                       {/*} <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={autoFill}
                              onChange={(event) => setAutoFill(event.target.checked)}
                            />
                          }
                          label="Automate the process"
                        /> */}
                      </Stack>

                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                        <LoadingButton loading={submitLoading} variant="contained" onClick={handleSubmitAddPartial}>
                          Add Partial Finished Product
                        </LoadingButton>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setOpenPartialPop(false);
                            setPartialModalOpen(false);
                            resetPartialModalFields();
                          }}
                          sx={{ marginLeft: '10px' }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </Modal>
          {!fromListTransfer && (
          <Stack direction="row" justifyContent="start" spacing={3} sx={{ px: 2, pt: 0.5, pb: 1 }}>
          <InventoryStockComparison materialId={editId} refreshData={refreshData} embedded />
         </Stack>
         )}
          <Stack direction="row" alignItems="center" justifyContent="start" spacing={3} sx={{p:3}}>
            <Switch
              checked={printerSettings}
              onChange={()=>{setPrinterSettings(!printerSettings)}}
            />
            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Print Settings
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '@keyframes rotate': {
                    '0%': { 
                      transform: 'rotate(0deg)' 
                    },
                    '100%': { 
                      transform: 'rotate(360deg)' 
                    }
                  },
                  animation: 'rotate 3s linear infinite',
                }}
              >
                <Icon 
                  icon={settingsOutline} 
                  width={28} 
                  height={28}
                  style={{ color: '#0daad9' }}
                />
              </Box>
            </Typography>
            <Tooltip
              arrow
              placement="right"
              title={
                <Typography variant="body2" sx={{ maxWidth: 320 }}>
                  Unit cost, total cost, and other amounts in this list may appear rounded (e.g. 5.98).
                  The value shown on hover is the full precision amount stored in the system and used for
                  inventory, refill, and job cost calculations.
                </Typography>
              }
            >
              <IconButton
                size="small"
                aria-label="About displayed amounts"
                sx={{
                  color: '#ff3b3b',
                  p: 0,
                  minWidth: 28,
                  minHeight: 28,
                  '@keyframes amountHelpAttention': {
                    '0%, 20%, 100%': {
                      transform: 'translate3d(0, 0, 0) rotate(0deg) scale(1)',
                      filter: 'drop-shadow(0 0 3px rgba(255, 59, 59, 0.55))',
                    },
                    '57%': {
                      transform: 'translate3d(0, -7px, 0) rotate(-12deg) scale(1.1)',
                      filter: 'drop-shadow(0 0 12px rgba(255, 59, 59, 1))',
                    },
                    '59%': {
                      transform: 'translate3d(-3px, 0, 0) rotate(12deg) scale(1.08)',
                    },
                    '61%': {
                      transform: 'translate3d(3px, -4px, 0) rotate(-10deg) scale(1.1)',
                    },
                    '63%': {
                      transform: 'translate3d(-3px, 0, 0) rotate(10deg) scale(1.06)',
                    },
                    '65%': {
                      transform: 'translate3d(3px, -2px, 0) rotate(-8deg) scale(1.08)',
                    },
                    '67%': {
                      transform: 'translate3d(0, 0, 0) rotate(0deg) scale(1)',
                      filter: 'drop-shadow(0 0 10px rgba(255, 59, 59, 0.95))',
                    },
                  },
                  animation: 'amountHelpAttention 2.8s ease-in-out infinite',
                  '&:hover': {
                    animationPlayState: 'paused',
                    transform: 'translate3d(0, 0, 0) rotate(0deg) scale(1)',
                    filter: 'drop-shadow(0 0 8px rgba(255, 59, 59, 0.9))',
                  },
                }}
              >
                <Icon icon={questionMarkCircleOutline} width={28} height={28} />
              </IconButton>
            </Tooltip>
          </Stack>
          <Scrollbar>
            <TableContainer ref={tableContainerRef} sx={{ minWidth: 800 }}>
              <Table>
              <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={slicedData?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                {loading ? (
                  <CircularProgress color="primary" variant="indeterminate" />
                ) : (
                  <>
                  {slicedData?.map((row) => {
                    let { id,	barcode, name, timestamp,unit_qty, status, unit_cost,qty,total_cost,autofill,partial_unit, authorized_by,source,vendor,partial_size,finished_product_barcode,convertion_unit, parent_finished_product_id: rowParentFinishedProductId, product_markup } = row;
                    const costPerUnit =  Number(qty) > 0
                    ? Number(Number(total_cost || 0) / Number(qty || 1))
                    : 0;
                    const markup =
    retailMarkup !== undefined && retailMarkup !== null && retailMarkup !== ''
      ? Number(retailMarkup) || 0
      : Number(product_markup) || 0;

  const markupAmount = (costPerUnit * markup) / 100;

  const sellingPrice = costPerUnit + markupAmount;
                    // if (qty <= 0) return null;
                    const isWithinLast24Hours = (timestamp) => {
                      const twentyFourHoursAgo = moment().subtract(24, 'hours');
                      const timestampMoment = moment.unix(timestamp); // Convert timestamp to moment object
                      return timestampMoment.isAfter(twentyFourHoursAgo);
                    };
                    const withinLast24Hours = isWithinLast24Hours(timestamp);
                    const isItemSelected = selected?.indexOf(id) !== -1;
                    const hasParentFinishedProduct =
                      rowParentFinishedProductId != null && rowParentFinishedProductId !== '';
                    const isUnlinkedRow = !hasParentFinishedProduct;
                    const defaultTextColor = theme.palette.mode === 'light' ? '#ff5b78' : '#ffc0cb';
                    const defaultAccentColor = theme.palette.mode === 'light' ? '#ff748d' : '#ffc0cb';
                    const cellColor = isUnlinkedRow ? theme.palette.text.primary : defaultTextColor;
                    const accentCellColor = isUnlinkedRow ? theme.palette.text.secondary : defaultAccentColor;
                    const unlinkedRowBg =
                      theme.palette.mode === 'light'
                        ? 'rgba(255, 235, 59, 0.22)'
                        : 'rgba(255, 193, 7, 0.16)';

                    return (
                      <TableRow
                        hover={!isUnlinkedRow}
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                        sx={
                          isUnlinkedRow
                            ? {
                                backgroundColor: unlinkedRowBg,
                                boxShadow: `inset 3px 0 0 ${theme.palette.warning.main}`,
                                '&:hover': { backgroundColor: unlinkedRowBg },
                                '&.Mui-selected': { backgroundColor: unlinkedRowBg },
                                '&.Mui-selected:hover': { backgroundColor: unlinkedRowBg },
                              }
                            : undefined
                        }
                      >
                        <TableCell padding="checkbox" onClick={handleScrollRight}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                            <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                          </IconButton>
                        </TableCell>
                        <TableCell>
                        
                          {withinLast24Hours && <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={ 'info' }
                          >
                            New
                          </Label>}
                        </TableCell>
                        <TableCell align="center">  
                          <Tooltip title={barcode}>                                     
                            <QRCode
                              value={`${PATH_DASHBOARD.products.viewFinished}/${id}`}
                              style={{ cursor: 'pointer' }}                             
                              size={70}
                              bgColor={isUnlinkedRow ? '#fffde7' : theme.palette.mode === 'light' ? '#ff748d' : '#ffc0cb'}
                              fgColor={'#000000'}
                            />
                          </Tooltip>    
                        </TableCell>
                        {fromTask ? <TableCell align="center" sx={{color: cellColor}} /> : <TableCell align="center" sx={{color: cellColor}}>
                          <Tooltip title={autofill == 1 ? "Automation Enabled" : "Automation Disabled"}>
                          <Checkbox
                            checked = {autofill == 1 ? true : false}
                          />
                          </Tooltip>
                          {/* {autofill == 1 ? 'Yes' : 'No'} */}
                        </TableCell>}
                        <Tooltip title={name || ""}>
                        <TableCell component="th" scope="row" padding="none"
                          sx={{
                            cursor: 'pointer',
                            maxWidth: 130, // Adjust as necessary
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: cellColor,
                            // display: 'block', // Change display to 'block'
                          }}
                        >
                          {/* <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
                            <Typography sx={{color:"#ffc0cb"}} variant="subtitle2" noWrap> */}
                              {name}
                            {/* </Typography>
                          </Stack> */}
                        </TableCell>
                        </Tooltip>
                        {fromTask ? <TableCell align="center" sx={{color: cellColor}} /> : <TableCell align="center" sx={{color: cellColor}}>{UNITS?.find(u => u.id == partial_unit)?.name || UNITS?.find(u => u.id == convertion_unit)?.name || unitName}</TableCell>}
                        {fromTask ? <TableCell align="center" sx={{color: cellColor}} /> :  <Tooltip title={sellingPrice}>
                          <TableCell align="center" sx={{ color: accentCellColor }}>
                            {sellingPrice.toFixed(2)}
                          </TableCell>
                        </Tooltip>
                          }
                        {fromTask ? <TableCell align="center" sx={{color: cellColor}} /> : <Tooltip title={unit_cost ? unit_cost : "0.00"}><TableCell align="center" sx={{color: accentCellColor}}>{unit_cost ? unit_cost?.toFixed(2) : 0.00}</TableCell></Tooltip>}
            
                        {/* <TableCell align="center" sx={{color:"#ffc0cb"}}>{unit_qty}</TableCell> */}
                        <Tooltip title={qty ? qty : "0.00"}><TableCell align="center" sx={{color: accentCellColor}}>{qty ? qty?.toFixed(2) : 0.00}</TableCell></Tooltip>
                        <TableCell align="center" sx={{color:"#ffc0cb"}}>{total_cost ? total_cost?.toFixed(2) : 0.00}</TableCell>                      
                        {fromTask ? <TableCell align="center" sx={{color: cellColor}} /> : <TableCell align="center" sx={{color: cellColor}}>{source==0 ? 'Inventory' : 'Vendor'}</TableCell>}  
                        {fromTask ? <TableCell align="center" sx={{color: cellColor}} /> : <Tooltip title={vendor || ""}>
                          <TableCell
                            align="center"
                            sx={{
                              cursor: 'pointer',
                              maxWidth: 130, // Adjust as necessary
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              color: cellColor,
                              // display: 'block', // Change display to 'block'
                            }}
                          >
                              {vendor}
                          </TableCell>
                        </Tooltip>}  
                        {/* <TableCell align="center" sx={{color:"#ffc0cb"}}>{moment.unix(timestamp).format('DD-MM-YYYY')}</TableCell> */}
                        <TableCell align="center" sx={{color: cellColor}}>{partial_size}</TableCell>
                        <TableCell align="center" sx={{color: cellColor}}>{finished_product_barcode}</TableCell>                   
                        <TableCell align="right">
                        <FinishedProductmenu
                          url={`${BASE_URL}view-finished-products/`}
                           id={id}  
                           name={name}  
                           barcode={barcode}
                           partial={true}
                           vpt_number={vpt_number}
                           description={description}
                           vendor={vendor}
                           printerSettings={printerSettings}
                        />
                        </TableCell>
                        <TableCell align="center">
                        {(viewFinishedProducts && !fromListTransfer) ? '' :
                          <MaterialInventoryMenu 
                            onDelete={() => handleDeleteUser(id)} 
                            userName={name} id={id} status={status} barcode={barcode}
                            partialFinishedProducts={true} 
                            noEdit={true}  
                            unitName={UNITS?.find(u => u.id == partial_unit)?.name || UNITS?.find(u => u.id == convertion_unit)?.name || unitName}
                            unit_cost={unit_cost}
                            qty={qty}
                            onEdit={(id)=>{setEditFinishedProductId(id);setOpenAddFinishedProduct(true) }} 
                            onRefresh={()=>{setRefreshData(!refreshData)}} 
                            maxQty={qty}
                            onDeletePartial={true}
                            datas={row}
                            fromListTransfer={fromListTransfer}
                          />
                        }
                        </TableCell>
                        <TableCell padding="checkbox" onClick={handleScrollLeft}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                            <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                  </>
                    )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} msg="Partial Finished Products"/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50,100]}
            component="div"
            count={filteredUsers?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </>
  );
}
